<template>
  <div class="container">
    
  </div>
</template>

<script>
export default {
  data() {
    return {
      isSticky: false,
    };
  },
  mounted() {
  },
  beforeDestroy() {
  },
  methods: {
   
  },
};
</script>

<style scoped>
.container {
  position: relative;
  height: 110vh;
  overflow-y: scroll;
}

.sticky-header {
  background-color: #fff;
  padding: 10px;
  opacity: 0;
  transition: opacity 0.5s ease-in-out;
}

.sticky-header.sticky {
  position: sticky;
  top: 0;
  opacity: 1;
  z-index: 10;
}

.content {
  padding: 20px;
  /* Add more content to enable scrolling */
}
</style>